module.exports = __webpack_public_path__ + "img/sports.c8d6a617.jpg";